import React from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';

export const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    const user = useSelector((state) => state['features/login'].user);
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return user ? (
      <Component
        {...props}
        _user={user}
        router={{ location, navigate, params }}
      />
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    );
  }
  return ComponentWithRouterProp;
};
